export default "__VITE_ASSET__D7QmQ4Y8__"